import "./index.css";

export const OpenBusinessTabs = ({ name, icon, key, onClick }) => {
  return (
    <div className="open-business-tabs" key={key} onClick={onClick}>
      <img
        src={icon}
        alt={`Business dashboard ${name} tab`}
        width={35}
        height={35}
      />
      <p>{name}</p>
    </div>
  );
};













